import { useQuery } from '@tanstack/react-query'
import { Spin } from 'antd'

import { useFramework } from '@suntex.fim/framework'

export function Version() {
  const { api } = useFramework()
  const { data } = useQuery({
    queryKey: ['debug', 'version'],
    queryFn: () => api.get_Debug_Version({})
  })

  if (!data) return <Spin />

  return (
    <>
      <h1>Application Version</h1>
      <style>{`td { padding: 10px; } `}</style>
      <table>
        <tr>
          <td>Build:</td>
          <td>
            <pre>{data.build}</pre>
          </td>
        </tr>
        <tr>
          <td>Commit Hash:</td>
          <td>
            <pre>{data.commitHash}</pre>
          </td>
        </tr>
      </table>
    </>
  )
}
